export default __webpack_public_path__ + "static/media/CE-Final.65bbde96.png";